import * as React from 'react';

import {Fallback} from './components/Fallback';
import {When, WhenProps} from './components/When';

interface Props {
  children: React.ReactNode;
}

function ContentSwitcher({children}: Props) {
  let matchingChild: React.ReactElement | undefined;
  let fallbackChild: React.ReactElement | undefined;

  React.Children.forEach(children, (child) => {
    if (!React.isValidElement(child)) {
      return;
    }

    if (!matchingChild && isWhenComponent(child)) {
      const conditionResult = getConditionResult(child.props.condition);

      if (conditionResult) {
        matchingChild = child;
      }
    } else if (!fallbackChild && child.type === Fallback) {
      fallbackChild = child;
    }
  });

  return matchingChild ?? fallbackChild ?? null;
}

function isWhenComponent(
  component: React.ReactElement<WhenProps> | React.ReactElement,
): component is React.ReactElement<WhenProps> {
  return component.props.condition !== undefined;
}

function getConditionResult(condition: WhenProps['condition']) {
  return typeof condition === 'function' ? condition() : condition;
}

ContentSwitcher.When = When;
ContentSwitcher.Fallback = Fallback;
export default ContentSwitcher;
